export default "__VITE_ASSET__CKW$LI1b__"